module.exports = __webpack_public_path__ + "static/bicyclebear-d9219ca1c9884304846c4a7f836771ec.jpeg";